import { Action, action } from "easy-peasy";

export interface CountryData {
  name: string;
  ISOCode: string;
}

export interface StoreModel {
  valentineMode: boolean;
  toggleValentineMode: Action<StoreModel>;
  focusedCountry: string;
  setFocusedCountry: Action<StoreModel, string>;
  detailsCountry: CountryData;
  setDetailsCountry: Action<StoreModel, CountryData>;
  sidebarOpen: boolean;
  toggleSidebar: Action<StoreModel, boolean>;
  reset: Action;
}

export let initState: any = {};

export const setInitState = (state: StoreModel) => {
  initState = state;
};

export const store: StoreModel = {
  valentineMode: false,
  toggleValentineMode: action(state => {
    state.valentineMode = !state.valentineMode;
  }),
  focusedCountry: "pl",
  setFocusedCountry: action((state, countryCode) => {
    state.focusedCountry = countryCode;
  }),
  detailsCountry: null,
  setDetailsCountry: action((state, detailsCountry) => {
    state.detailsCountry = detailsCountry;
  }),
  sidebarOpen: false,
  toggleSidebar: action((state, isOpen) => {
    state.sidebarOpen = isOpen;
  }),
  reset: action(() => initState)
};
